import React from "react";
import "./EligibilitySection.css";
import { CheckCircle, XCircle } from "lucide-react";

const EligibilitySection = () => {
  return (
    <section id="eligibility" className="eligibility-section">
      <div className="eligibility-container">
        <h2 className="eligibility-title">🩸 Who Can Donate?</h2>
        <p className="eligibility-subtitle">
          Before donating blood, check if you meet the health and lifestyle criteria.
        </p>

        {/* 2-column layout */}
        <div className="eligibility-main">
          {/* Left: Image */}
          <div className="eligibility-image">
            <img src="\assets\bloodlogo.png" alt="Blood donation" />
          </div>

          {/* Right: stacked cards */}
          <div className="eligibility-cards">
            <div className="eligibility-box eligible-box animate">
              <div className="eligibility-box-header">
                <CheckCircle size={30} className="icon success" />
                <h3>You Can Donate If</h3>
              </div>
              <ul>
                <li>✅ Age between <strong>18 - 65 years</strong></li>
                <li>✅ Weight at least <strong>50 kg</strong></li>
                <li>✅ In <strong>good health</strong></li>
                <li>✅ Hemoglobin <strong>12.5 g/dL+</strong></li>
                <li>✅ At least <strong>3 months since last donation</strong></li>
                <li>✅ Not on restricted medicines</li>
              </ul>
            </div>

            <div className="eligibility-box not-eligible-box animate">
              <div className="eligibility-box-header">
                <XCircle size={30} className="icon danger" />
                <h3>Avoid Donation If</h3>
              </div>
              <ul>
                <li>❌ Have <strong>cold, flu or fever</strong></li>
                <li>❌ Taking <strong>antibiotics/blood thinners</strong></li>
                <li>❌ Got a <strong>tattoo/piercing in last 6 months</strong></li>
                <li>❌ <strong>Pregnant</strong> or breastfeeding</li>
                <li>❌ Chronic illness like <strong>HIV, Hepatitis, Cancer</strong></li>
                <li>❌ Recent major surgery/infection</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Quiz Section */}
        {/* <div className="quiz-box animate">
          <h4>🧠 Not Sure?</h4>
          <p>Take a 30-second quiz to quickly check your eligibility for blood donation.</p>
          <button
            className="quiz-btn"
            onClick={() => alert("🚧 Quiz feature coming soon!")}
          >
            Start Quiz
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default EligibilitySection;
